import { Directive, Input, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InsuranceMetadatas } from 'src/app/_types/lead.types';

@Directive()
export abstract class LeadFormBase implements OnInit {
  @Input()
  metadata?: InsuranceMetadatas;

  handleSubmit(): Observable<boolean> {
    return of(true);
  }

  ngOnInit() {}
}
